import axios from 'axios';

import { removeFulfillmentPlansFromBatchPromise } from '../../../store/batches/details/batch.details.api';

export const createPickBatchFromLabelBatch = (fulfillmentPlanSetId) => {
  return axios.post(`/pick-batches/create-pick-batch-from-label-batch?labelBatchId=${fulfillmentPlanSetId}`);
};

export const validateOrder = (fulfillmentPlanIds, isBatch) => {
  return axios.post('/pick-batches/validate-orders', {
    fulfillmentPlanIds,
    includeLabelBatchValidation: !isBatch,
  });
};

export const addOrdersToQueue = (fulfillmentPlanIds, inventoryWarehouseId) => {
  return axios.post('/pick-batches/queue/add', { fulfillmentPlanIds, inventoryWarehouseId });
};

export const stopPickingOrders = async (fulfillmentPlanIds) => {
  return axios.post('/pick-batches/stop-picking-orders', { fulfillmentPlanIds });
};

export const removeOrdersFromBatches = async (fulfillmentPlanIds) => {
  const { data: validationResults } = await validateOrder(fulfillmentPlanIds, false);

  const batchToOrderIds = validationResults.reduce((acc, order) => {
    if (!order.fulfillmentPlanSetId) {
      return acc;
    }
    const batchId = order.fulfillmentPlanSetId;
    return { ...acc, [batchId]: [...(acc[batchId] ?? []), order.fulfillmentPlanId] };
  }, {});

  await Promise.all(Object.entries(batchToOrderIds).map(([batchId, fpIds]) => removeFulfillmentPlansFromBatchPromise(batchId, fpIds)));
};
